import { createContext } from 'react';
import { EBrand } from '../typings/enums/Brands';

export const BrandContext = createContext<EBrand>(EBrand.Mac); // defaults to MAC
